import { Table, TableBody, TableCell, TableHeader, TableRow } from "@/components/ui/table"

import { type DigesterMetricsTableConfig } from "../types/feedstockTypes"

import Digester7DayMetrics from "./Digester7DayMetrics"
import DigesterKPIs from "./DigesterKPIs"
import LiveDigesterMetrics from "./LiveDigesterMetrics"

export default function DigesterMetricsTable({ config }: { config: DigesterMetricsTableConfig }) {
  return (
    <div className="rounded-md border shadow-sm h-[calc(100vh-175px)] overflow-x-auto">
      <Table>
        <TableHeader className="sticky bg-card-header-light top-0 z-100">
          <TableRow>
            <TableCell className="p-4">Metric</TableCell>
            {config.groups.map((g) =>
              g.digesters.map((d, i) => (
                <TableCell key={i} className="p-4">
                  {d.key}
                </TableCell>
              )),
            )}
            <TableCell className="p-4 font-semibold">Total</TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          <LiveDigesterMetrics
            groups={config.groups}
            metrics={config.liveMetrics}
            colorRanges={config.colorRanges}
          />
          <Digester7DayMetrics
            groups={config.groups}
            colorRanges={[[], config.colorRanges[0], config.colorRanges[4]]}
          />
          <DigesterKPIs
            groups={config.groups}
            kpis={config.kpis}
            kpiTotals={config.kpiTotals}
            colorRanges={config.colorRanges}
          />
        </TableBody>
      </Table>
    </div>
  )
}
